export default function reducer(state = {
  sucursalesFD: undefined,
  lastFetched: undefined
}, action) {
  switch (action.type) {
    case "LOAD_SUCURSALES_FD": {
      state = { ...state, ...action.payload }
      break
    }
    default: {

    }
  }
  return state
}